/* eslint-disable camelcase */
import { Box, NavList, Paragraph, WarningIcon } from '@deckee/deck-hand';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import RegulationCard from '../components/RegulationCard';
import RegulationLocationCard from '../components/RegulationLocationCard';
import { callEndpoint } from '../../../../services/backend';
import {
  transitionToNextRoute,
  transitionToPreviousRoute,
} from '../../../../services/route/route-navigation';
import { showSelectMapPoint } from '../../../../services/store/modules/app-controls';
import { ROUTE_MARKER_SUMMARY_DETAILS } from '../../../../services/route/route-names';

const handleSelectRegulation = async ({ url }: { url: string }) => {
  transitionToNextRoute(ROUTE_MARKER_SUMMARY_DETAILS, {
    url: encodeURIComponent(url),
  });
};

const RegulationListPage: React.FC<{
  latitude: number;
  longitude: number;
}> = ({ latitude, longitude }) => {
  const theme = useTheme();
  const [regulations, setRegulations] = useState<
    {
      regulation_card: {
        title: string;
        description: string;
      };
      details_available: boolean;
      url: string;
    }[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const updateRegulations = async () => {
      setIsLoading(true);
      setRegulations(
        await callEndpoint(callEndpoint.endpoints.getRegulationsByLocation, {
          ':latitude': latitude,
          ':longitude': longitude,
        }),
      );
      setIsLoading(false);
    };
    dispatch(showSelectMapPoint(-1));
    updateRegulations();
  }, [latitude, longitude, dispatch]);

  return (
    <BasicDrawerLayout
      heading="Regulations"
      loading={isLoading}
      onBack={() => transitionToPreviousRoute()}
    >
      <Box p={3}>
        <NavList>
          <RegulationLocationCard
            latitude={latitude}
            longitude={longitude}
            chevron={false}
          />
          {!(regulations.length > 0) && (
            <NavList.Item>
              <WarningIcon color={theme.colors.primary} />
              <Paragraph level={6} m="0" mb="1">
                No known regulations in this area
              </Paragraph>
            </NavList.Item>
          )}
          <div role="list" aria-label="regulations-list">
            {regulations.map(
              ({
                regulation_card: { title, description },
                url,
                details_available,
              }) => (
                <RegulationCard
                  key={url}
                  title={title}
                  description={description}
                  detailsAvailable={details_available}
                  url={url}
                  role="listitem"
                  onSelectRegulation={handleSelectRegulation}
                />
              ),
            )}
          </div>
        </NavList>
      </Box>
    </BasicDrawerLayout>
  );
};

export default RegulationListPage;
